import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-array-index-key */
import React from 'react';
import classNames from 'classnames'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import omit from 'lodash/omit';
import PropTypes from 'prop-types'; // eslint-disable-next-line import/no-unresolved -- directive added automatically by Shepherd migration

import classes from '@nerdwallet/base-styles/classes';
import styles from './image.module.less'; // Remove custom props that should not
// be applied to the DOM element

var omitExtraneous = function omitExtraneous(source) {
  return omit(source, ['aspectRatio', 'backgroundColor', 'caption', 'children', 'className', 'expandToContent', 'imageClassName', 'lazy', 'naturalHeight', 'naturalWidth', 'objectFit', 'objectPosition', 'offset', 'overflow', 'placeholderImage', 'sources']);
};

var Picture = function Picture(props) {
  var alt = props.alt,
      title = props.title,
      className = props.className,
      src = props.src,
      srcSet = props.srcSet,
      sizes = props.sizes,
      objectFit = props.objectFit,
      sources = props.sources,
      expandToContent = props.expandToContent,
      objectPosition = props.objectPosition,
      error = props.error,
      placeholderImage = props.placeholderImage,
      onLoad = props.onLoad;
  var imgProps = {
    alt: alt,
    title: title,
    className: classNames(className, styles.image, _defineProperty({}, classes('position-absolute'), expandToContent)),
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    style: {
      objectPosition: objectPosition,
      objectFit: objectFit
    },
    onLoad: onLoad
  };

  if (error) {
    // Bail on sources, and render an img tag using placeholder image.
    delete imgProps.srcSet;
    imgProps.src = placeholderImage;
    /* `alt` is part of `imgProps` above. */

    /* eslint-disable-next-line jsx-a11y/alt-text */

    return /*#__PURE__*/React.createElement("img", imgProps);
  }

  var fallbackSrc; // Multiple sources return a <picture> element

  var sourceTags = sources.map(function (source, index) {
    var _omitExtraneous = omitExtraneous(source),
        sourceSrc = _omitExtraneous.src,
        sourceSrcSet = _omitExtraneous.srcSet,
        sourceSizes = _omitExtraneous.sizes,
        sourceProps = _objectWithoutProperties(_omitExtraneous, ["src", "srcSet", "sizes"]);

    if (sourceSrc && !fallbackSrc) {
      fallbackSrc = sourceSrc;
    }

    return /*#__PURE__*/React.createElement("source", _extends({}, sourceProps, {
      src: sourceSrc,
      srcSet: sourceSrcSet || sourceSrc,
      sizes: sourceSizes,
      key: index
    }));
  });
  return sources.length > 1 ? /*#__PURE__*/React.createElement("picture", null, sourceTags, /*#__PURE__*/React.createElement("img", _extends({}, imgProps, {
    src: src || fallbackSrc
  }))) :
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/alt-text
  React.createElement("img", _extends({}, imgProps, omitExtraneous(sources[0])));
};

Picture.displayName = 'Picture';
Picture.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.bool,
  expandToContent: PropTypes.bool,
  media: PropTypes.string,
  objectFit: PropTypes.string,
  objectPosition: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onLoad: PropTypes.func,
  placeholderImage: PropTypes.string,
  sources: PropTypes.arrayOf(PropTypes.shape({
    media: PropTypes.string,
    srcSet: PropTypes.string,
    sizes: PropTypes.string
  })),
  src: PropTypes.string,
  srcSet: PropTypes.string,
  sizes: PropTypes.string,
  title: PropTypes.string
};
Picture.defaultProps = {
  sources: []
};
export default Picture;